import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-gm",
  "use": "icon-icon-gm-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-gm\">\n  <g fill-rule=\"evenodd\" stroke-width=\"1pt\">\n    <path fill=\"red\" d=\"M0 0h512v170.7H0z\" />\n    <path fill=\"#fff\" d=\"M0 170.7h512V199H0z\" />\n    <path fill=\"#009\" d=\"M0 199.1h512V313H0z\" />\n    <path fill=\"#fff\" d=\"M0 312.9h512v28.4H0z\" />\n    <path fill=\"#090\" d=\"M0 341.3h512V512H0z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol